// Library Imports
import React, { useState } from 'react';
import { useAuth } from '../../hooks/AuthProvider';
import { Button, Container, Form, Alert } from 'react-bootstrap';
// Asset Imports
import '../../assets/css/stylesheets/LoginForm.css';

function LoginForm() {
    const [input, setInput] = useState({
      username: "",
      password: "",
    });
    const [rememberMe, setRememberMe] = useState(false);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    const auth = useAuth();
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setError(null);
      setIsLoading(true);
  
      if (input.username && input.password) {
        try {
          await auth.loginAction(input, rememberMe);
        } catch (error) {
          setError(error.message || "Login failed");
        } finally {
          setIsLoading(false);
        }
      } else {
        setError("Please provide a valid username and password");
        setIsLoading(false);
      }
    };
  
    const handleInput = (e) => {
      const { name, value } = e.target;
      setInput((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
  
    const handleCheckbox = (e) => {
      setRememberMe(e.target.checked);
    };
  
    return (
      <Container className="loginform-container">
        <h3>Login</h3>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit} className="loginform-form">
          <Form.Group>
            <Form.Label className="loginform-label" htmlFor="inputUsername">
              Username
            </Form.Label>
            <Form.Control
              name="username"
              value={input.username}
              onChange={handleInput}
              required
              className="loginform-control"
              type="text"
              disabled={isLoading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="loginform-label" htmlFor="inputPassword">
              Password
            </Form.Label>
            <Form.Control
              name="password"
              value={input.password}
              onChange={handleInput}
              required
              className="loginform-control"
              type="password"
              disabled={isLoading}
            />
          </Form.Group>
          <Form.Group className="loginform-submit-group">
            <Button
              className="loginform-submit-button"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </Button>
            <Form.Check
              onChange={handleCheckbox}
              checked={rememberMe}
              type="checkbox"
              id="inputRemember"
              label="Remember Me"
              disabled={isLoading}
            />
          </Form.Group>
        </Form>
      </Container>
    );
  }
  
  export default LoginForm